import { Badge, type BadgeTone, Tooltip } from '@skupreme/shared/ui';
import { BAND_LABELS, bandOf, percent } from '../../lib/bands';
import type { ConfidenceBand } from '../../lib/suggestion-types';

const BAND_TONES: Record<ConfidenceBand, BadgeTone> = {
  high: 'success',
  medium: 'caution',
  low: 'warning',
};

/** High, Medium or Low; the percentage shows on hover. */
export function ConfidenceChip({ confidence }: { confidence: number }) {
  const band = bandOf(confidence);

  return (
    <Tooltip content={`${percent(confidence)} sure`}>
      <Badge tone={BAND_TONES[band]}>{BAND_LABELS[band]}</Badge>
    </Tooltip>
  );
}

/** "2-pack" when the listing sells more than one unit of the product. */
export function PackBadge({ pack }: { pack: number }) {
  return pack > 1 ? <Badge tone="info">{pack}-pack</Badge> : null;
}
